import React, { useState, useEffect } from "react";
import './style.scss';
import { Layout, Space, PageHeader, message } from 'antd';
import AddDetails from "./childrens/addDetails";
import CustomizationCard from "./childrens/customizationCard";
import FooterBtns from "./childrens/footerBtns";
import MenuService from '../../services/MenuService';
import MenuCustomizeService from '../../services/MenuCustomizeService';
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Content } = Layout;

const NewCustomization = (props) => {
    const { addNew, adminRestaurant, newCustom, setAddNew, getCustomizationList } = props;
    const [menuGroups, setMenuGroups] = useState({});
    const [menuItems, setMenuItems] = useState({});
    const [isCustomised, setIsCustomised] = useState(addNew.menu_id ? false : true);
    const [menuDetails, setMenuDetails] = useState({});
    const [customData, setCustomData] = useState(addNew === true ? newCustom : addNew);
    const getmenuDetails = async() => {
        const Details = await MenuService.getMenus(adminRestaurant);
        setMenuDetails(Details);
    };
    const onMenuChange = (e, f) => {
        const currentData = {...customData};
        currentData.menu_id = e;
        currentData.menu_group_id = null;
        currentData.menu_customization_menu_items = [];
        currentData.menu_customization_exceptions = [];
        currentData.menu_customization_addons = [];
        setCustomData(currentData);
        getmenuGroups(e);
    };
    const getmenuGroups = async(id) => {
        const groups = await MenuCustomizeService.menugroupById(id);
        setMenuGroups(groups);
    };
    const getmenuGroupsItem = async(id) => {
        const groupsItem = await MenuCustomizeService.getMenuGroupItems(id);
        setMenuItems(groupsItem);
    };
    useEffect(() => {
        getmenuDetails();
        if(addNew.menu_id ){
            getmenuGroups(addNew.menu_id)
        }
        if(addNew.menu_group_id ){
            getmenuGroupsItem(addNew.menu_group_id);
        }
    }, [])
    const changeCostType = (key, value, field) => {
        const currentData = {...customData};
        currentData[field][key].has_added_cost = value;
        currentData[field][key].options = "[]";
        currentData[field][key].items = [{ option_name: "", cost: 0 }];
        setCustomData(currentData);
    };
    const selectableChange = (key, value, field) => {
        const currentData = {...customData};
        currentData[field][key].num_selectable_options = value;
        setCustomData(currentData);
    };
    const onLabelChange = (key, e, field) => {
        const currentData = {...customData};
        currentData[field][key].label = e.target.value;
        setCustomData(currentData);
    };
    const onAddNewCard = (e) => {
        const currentData = {...customData};
        currentData[e.key].push({
            "label": "",
            "num_selectable_options": 5,
            "has_added_cost": e.key === 'menu_customization_preferences' ? false : true,
            "options": '[]',
            "items": e.key === 'menu_customization_preferences' ? [] : [{ option_name: "", cost: 0 }]
            // 'menu_customization_addons':[]
        });
        setCustomData(currentData);
    };
    const ondeleteCard = (key, field) => {
        const currentData = {...customData};
        currentData[field].splice(key, 1);
        setCustomData(currentData);
    };
    const onAddNewCostRow = (key, field) => {
        const currentData = {...customData};
        if(currentData[field][key].items){
            currentData[field][key].items?.push({ cost: 0, option_name: "" });
        } else {
            currentData[field][key].items=[{ cost: 0, option_name: "" }];
        }
        setCustomData(currentData);
    };
    const onDeleteCostRow = (key, rowIndex, field) => {
        const currentData = {...customData};
        currentData[field][key].items.splice(rowIndex, 1);
        setCustomData(currentData);
    };
    const groupByCostFlag = (hasCost) => {
        const allData = [...customData.menu_customization_preferences, ...customData.menu_customization_addons];
       const newList = allData.filter((item)=> item.has_added_cost === hasCost);
       const idRemoved = [];
       newList.map((itm)=>{
            delete itm.id;
            itm.items?.map((subItm)=>{
                delete subItm.id;
                return subItm;
            })
            idRemoved.push(itm);
       })
       return idRemoved;

    };
    const onSaveCustomization = async() => {
        if(customData.id){
            let updateData = { ...customData }
            delete updateData.id;
            delete updateData.menus;
            delete updateData.menu;
            delete updateData.menu_group;
            updateData.menu_customization_preferences = groupByCostFlag(false);
            updateData.menu_customization_addons = groupByCostFlag(true);
            updateData.menu_customization_exceptions = customData.menu_customization_exceptions.map((it)=>({menu_item_id:it.menu_item_id}));
            const updateRes = await MenuCustomizeService.updateMenuCustomization(updateData, customData.id);
            if(updateRes && !updateRes.err){
             message.success(updateRes?.msg);
            } else {
              message.error('Something went wrong');
            }
            setAddNew(false);
            getCustomizationList();
        } else {
            let updateData = { ...customData }
            updateData.menu_customization_preferences = groupByCostFlag(false);
            updateData.menu_customization_addons = groupByCostFlag(true);
            const saveRes = await MenuCustomizeService.saveMenuCustomization(updateData);
            if(saveRes && !saveRes?.err){
                message.success(saveRes?.msg);
            } else {
                   message.error('Something went wrong');
            }
            setAddNew(false);
            getCustomizationList();
        }
        // setAddNew(false);
    };
    const onChangeName = (e) => {
        const currentData = {...customData};
        currentData.name = e.target.value;
        setCustomData(currentData);
    };
    const onMenuGroupChange = (e) => {
        const currentData = {...customData};
        currentData.menu_group_id = e;
        currentData.menu_customization_menu_items = [];
        currentData.menu_customization_exceptions = [];
        currentData.menu_customization_addons = [];
        setCustomData(currentData);
        getmenuGroupsItem(e);
    };
    const onCostDataChange = (key, rowIndex, e, field, fieldKey) => {
        const currentData = {...customData};
        currentData[fieldKey][key].items[rowIndex][field]= field === 'cost' ? e : e.target.value;
        setCustomData(currentData);
    };
    const onChangeCustomise = (val) => {
        setIsCustomised(val);
        const currentData = {...customData};
        currentData.menu_id = null;
        currentData.menu_group_id = null;
        currentData.menu_customization_menu_items = [];
        currentData.menu_customization_exceptions = [];
        currentData.menu_customization_addons = [];
        setCustomData(currentData);

    };
    const onAddOptions = (key, field) => {
        const currentData = {...customData};
        let currentOption = JSON.parse(currentData.menu_customization_preferences[key].options);
        currentOption.push(field);
        currentData.menu_customization_preferences[key].options = JSON.stringify(currentOption);
        setCustomData(currentData);
    };
    const removeFromOption = (key,field) => {
        const currentData = {...customData};
        let newData = field.map((newOpt)=>{ return newOpt.value });
        currentData.menu_customization_preferences[key].options= JSON.stringify(newData);
        setCustomData(currentData);
    };
    const onMenuItemChange = (e) => {
        const currentData = {...customData};
        currentData.menu_customization_menu_items = e.map((itm)=>({menu_item_id: itm}));
        setCustomData(currentData);
    };
    const onMenuExcepChange = (e) => {
        const currentData = {...customData};
        currentData.menu_customization_exceptions = e.map((exc)=>({menu_item_id: exc}));
        setCustomData(currentData);
    };
    const onMenuAddOnChange = (e) => {
        const currentData = {...customData};
        currentData.menu_customization_addons = e.map((exc)=>({menu_item_id: exc}));
        setCustomData(currentData);
    };
    const onCancel = () => {
        setAddNew(false);
    };
    return (
            <Content
                className="add_customization"
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <PageHeader
                    className="page-header"
                        title={<div><ArrowLeftOutlined onClick={() => setAddNew(false)} style={{marginRight:"15px"}} className="backarrow"/>Add New Customization</div>}
                        extra={[]} />
                        <AddDetails 
                            customData={customData} 
                            onChangeName={onChangeName} 
                            menuGroups={menuGroups}
                            onMenuGroupChange={onMenuGroupChange}
                            menuItems={menuItems}
                            onChangeCustomise={onChangeCustomise}
                            isCustomised={isCustomised}
                            onMenuItemChange={onMenuItemChange}
                            onMenuExcepChange={onMenuExcepChange}
                            onMenuAddOnChange={onMenuAddOnChange}
                            menuDetails={menuDetails}
                            onMenuChange={onMenuChange} 
                        />
                        <>
                        {customData.menu_customization_preferences.map((item, key)=> {
                            return <CustomizationCard
                             showCost={item.has_added_cost}
                             item= {item}
                             index={key}
                            //  key={key}
                             menuCustomizationAddons={item?.items}
                             onLabelChange= {onLabelChange}
                             selectableChange= {selectableChange}
                             onAddNewCostRow = {onAddNewCostRow}
                             onDeleteCostRow= {onDeleteCostRow}
                             changeCostType ={ changeCostType}
                             ondeleteCard={ondeleteCard}
                             onCostDataChange={onCostDataChange}
                             onAddOptions={onAddOptions}
                             removeFromOption={removeFromOption}
                             field="menu_customization_preferences"
                            />
                        })}
                        {customData.menu_customization_addons.map((item, key)=> {
                            return <CustomizationCard
                             showCost={item.has_added_cost}
                             item= {item}
                             index={key}
                            //  key={key}
                             menuCustomizationAddons={item.items}
                             onLabelChange= {onLabelChange}
                             selectableChange= {selectableChange}
                             onAddNewCostRow = {onAddNewCostRow}
                             onDeleteCostRow= {onDeleteCostRow}
                             changeCostType ={ changeCostType}
                             ondeleteCard={ondeleteCard}
                             onCostDataChange={onCostDataChange}
                             onAddOptions={onAddOptions}
                             removeFromOption={removeFromOption}
                             field="menu_customization_addons"
                            />
                        })}
                        </>
                        {/* <CustomizationCard showCost={true} /> */}
                        {/* <CustomizationCard showCost={false} /> */}
                        <FooterBtns 
                            onAddNewCard={onAddNewCard} 
                            onCancel={onCancel}
                            customData={customData}
                            onSaveCustomization = {onSaveCustomization}
                        />
                </Space>
            </Content>
    )
}
export default NewCustomization;
